import { render, staticRenderFns } from "./TradeSellOfferForms.vue?vue&type=template&id=20fea23c&scoped=true&"
import script from "./TradeSellOfferForms.vue?vue&type=script&lang=ts&"
export * from "./TradeSellOfferForms.vue?vue&type=script&lang=ts&"
import style0 from "./TradeSellOfferForms.vue?vue&type=style&index=0&id=20fea23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fea23c",
  null
  
)

export default component.exports